









import RatingTable from "@/components/rating/RatingTable.vue";
import MHeader from "@/components/utility/mmmint/MHeader.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    RatingTable,
    TheLayoutPortal,
    MHeader
  }
})
export default class RatingView extends mixins(PartnerFallbackMixin) {
  async mounted() {
    this.trySetByRouteOrDefault();
  }
}
